import React from 'react'
import { Form, InputContainer, ButtonsContainer, Button, EmptyBancos } from './DepositElements';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../utils/tools';
import { useSelector } from 'react-redux';
import { selectCurrency } from '../../features/user/userSlice';
import Loader from '../common/Loader';

const FormPayRetailers = ({form, handleChange, handleClose, handleSubmit, loading, loadingBancos, bancos}) => {
  const [t] = useTranslation('global');
  const moneda = useSelector(selectCurrency);

  const formatChannel = (str) => {
    if(str==='ONLINE') return "Online";
    if(str==='CASH') return "Efectivo";
  }

  const formatName = (str) => {
    if(str==='Banco de Crédito') return "Banco de Crédito BCP";
    else return str;
  }

  return (
    bancos.length>0 ? 
      <Form>
        <InputContainer>
          <label>{t('deposit.lbl-bank')}</label>
          <select value={form.nombreBanco} onChange={handleChange} name='nombreBanco' >
            <option disabled value=''>{t('deposit.input-bank')}</option>
            {bancos.map(item => <option key={item.paymentMethodId} value={`${item.name}_${item.paymentMethodId}`}>{moneda==='Sol'?formatName(item.name):item.name} ({formatChannel(item.channel)})</option>)}
          </select>
        </InputContainer>
  
        <InputContainer>
          <label>{t('deposit.name')}:</label>
          <input type='text' placeholder={t('deposit.name')} name='nombre' value={form.nombre} onChange={handleChange} />
        </InputContainer>

        <InputContainer>
          <label>{t('deposit.last-name')}:</label>
          <input type='text' placeholder={t('deposit.last-name')} name='apellido' value={form.apellido} onChange={handleChange} />
        </InputContainer>


        <InputContainer>
          <label>{t('deposit.id')}:</label>
          <input type='text' placeholder={t('deposit.id')} name='cedula' value={form.cedula} onChange={handleChange} />
        </InputContainer>

        <InputContainer>
          <label>{t('deposit.email')}:</label>
          <input type='text' placeholder={t('deposit.email')} name='email' value={form.email} onChange={handleChange} />
        </InputContainer>
  
        {(moneda==='COP'||moneda==='BRL') &&
        <>
          <InputContainer>
            <label>{t('deposit.city')}:</label>
            <input type='text' placeholder={t('deposit.city')} name='ciudad' value={form.ciudad} onChange={handleChange} />
          </InputContainer>
          
          <InputContainer>
            <label>{t('deposit.address')}:</label>
            <input type='text' placeholder={t('deposit.address')} name='direccion' value={form.direccion} onChange={handleChange}/>
          </InputContainer>
        </>
        } 

        <InputContainer>
          <label>{t('deposit.lbl-amount')}</label>
          <input type='text' placeholder='0,00' name='monto1' value={form.monto1} onChange={(e)=>handleChange(formatNumber(e))}/>
        </InputContainer>

        <ButtonsContainer>
          <Button onClick={(e)=> {
            e.preventDefault();
            handleClose();
          }}>{t('deposit.btn-cancel')}</Button>
          <Button primary={true} disabled={loading} onClick={handleSubmit}>{loading ? t('deposit.loading') : t('deposit.btn-confirm')}</Button>
        </ButtonsContainer>
      </Form>
      : <EmptyBancos>
        {
          loadingBancos ? 
            <Loader/>
          :
          <>
            <div style={{color: 'white', textAlign: 'center'}}>{t("deposit.no-countries")}</div> 
            <div className='yellow'>{t("deposit.try-another-method")}.</div>
          </>
        }
        
      </EmptyBancos>
    
  )
}

export default FormPayRetailers